export default __webpack_public_path__ + "static/media/video-lesson.0da43bb2.svg";